/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Instructor} from '../../core/_models'

type Props = {
  user: Instructor
  type: String
}

const InstructorInfoCell: FC<Props> = ({user, type}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}

    {/* <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <a href='#'>
        {user && user?.profileImageUrl ? (
          <div className='symbol-label'>
            <img src={user?.profileImageUrl} alt={'image'} className='w-100' />
          </div>
        ) : (
          user?.name && (
            <div
              className={clsx(
                'symbol-label fs-3',
                `bg-light-${user?.name[0] || 'a'}`,
                `text-${user?.name[0] || 'a'}`
              )}
            >
              {user?.name[0]}
            </div>
          )
        )}
      </a>
    </div> */}

    {/* {!user?.profileImageUrl && !user?.name && <div className='symbol-label fs-3'>N/A</div>} */}
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 text-hover-primary mb-1'>
        {type === 'instructor' ? user.name : user?.firstName + ' ' + user?.lastName}
      </a>

      {/* <span
        // style={{textOverflow: (user.email.length) > 15 ? 'ellipsis' : ''}}>{user.email}
        style={{
          textOverflow: 'none',
          overflow: 'none',

          whiteSpace: 'nowrap',
        }}
      >
        {user?.email}
      </span> */}
    </div>
  </div>
)

const formatName = (name) => {
  if (name.length > 30) {
    return name.slice(0, -5) + '...'
  } else {
    return name
  }
}

export {InstructorInfoCell}
